import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';

@Component({
    selector: 'ea-column-chart',
    templateUrl: './ea-column.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./ea-column.component.scss'],
    standalone: false
})
export class EaColumnComponent implements OnInit, OnChanges {
  Highcharts: typeof Highcharts = Highcharts;
  @Input() options: any;
  @Input() data: any;
  @Input() valueSuffix = '€';
  @Input() title: any;
  @Input() height = '280px';
  @Input() width = '100%';
  @Input() showLegend: boolean = true;
  @Input() series;
  @HostBinding('class.entrance') @Input() animated: boolean = false;
  @HostBinding('class.placeholder') @Input() placeholder: boolean = false;
  readonly placeholderColumns = [
    [66, 31],
    [60, 29],
    [56, 26],
    [53, 25],
    [47, 22],
    [40, 18],
  ];

  columnOptions: any;
  private chart: Highcharts.Chart | null = null;

  constructor(
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  onChartInstance(chart: Highcharts.Chart | null): void {
    this.chart = chart;
    setTimeout(() => this.chart?.reflow());
  }

  ngOnInit() {
    this.initOptions();
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  initOptions(): void {
    let opt = this.getDefaultOption();
    if (this.options) {
      opt = _.merge(opt, this.options, { series: this.series });
      this.columnOptions = opt;
    }

    /* format series data */
    if (this.data && this.data instanceof Array) {
      this.columnOptions = this.processChartOptions(this.data);
    }
  }

  processChartOptions(data: any): any {
    let options = this.getDefaultOption();

    if (data instanceof Array) {
      let categories = [],
        series = [];
      data.forEach((s, index) => {
        if (s.data && s.data.length > 0) {
          let tmp = [];
          this.translate.get(s.name).subscribe(trans => {
            s.data.forEach(obj => {
              if (index === 0) {
                categories.push(obj.type);
              }
              tmp.push(obj.value);
            });
            series.push({ name: trans, data: tmp });
          });
        }
      });

      options.xAxis.categories = categories;
      options.series = series;
    }

    return options;
  }

  getDefaultOption(): any {
    let options = {
      chart: {
        type: 'column',
        backgroundColor: 'transparent',
        height: this.height ? parseInt(this.height, 10) || null : null,
      },
      credits: {
        enabled: false,
      },
      colors: [
        '#1E40AF',
        '#F5A800',
        '#33A02C',
        '#FF7F00',
        '#D90000',
        '#C36363',
      ],
      title: {
        text: '',
      },
      xAxis: {
        crosshair: true,
      },
      yAxis: {
        title: {
          text: '',
        },
      },
      mapNavigation: {
        enableTouchZoom: false,
      },
      tooltip: {
        enabled: true,
        split: true,
        valueSuffix: this.valueSuffix,
        valueDecimals: 2,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
        series: {
          showInLegend: this.showLegend,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format:
              '<b style="color:{point.color}">{point.y:.2f} ' +
              this.valueSuffix +
              '</b>',
          },
        },
      },
      series: [],
    };

    return options;
  }
}
